import { MutationTree } from "vuex";
import { CATEGORIAS } from "./types";

type CategoriaMutationTree = MutationTree<CATEGORIAS>;

export const mutations: CategoriaMutationTree = {};
